import React, { useRef } from 'react'
import emailjs from "@emailjs/browser";
import { useLocation } from "react-router-dom";

function BookADemo() {

  const formRef = useRef();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const product = queryParams.get("product");

  const sendEmail = (e) => {
    e.preventDefault(); // prevent page reload

    // Send email via EmailJS
    emailjs
      .sendForm(
        "service_bgh4cm2", // EmailJS Service ID
        "template_demo_80vv4xn", // EmailJS Template ID
        formRef.current,
        "q13BP6L2yKDgfSf7B" // EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);
          alert("Thank You for Booking a free demo. We will take this request on proirity!");
          formRef.current.reset(); // reset form
        },
        (error) => {
          console.log(error.text);
          alert("Failed to send message. Please try again.");
        }
      );
  };

  return (
    // <div
    //   style={{
    //     borderLeft: "150px solid  #0C2B4B",   // left border 
    //     borderRight: "150px solid #0C2B4B",  // right border    
    //     height: "100vh",
    //     minHeight: "100vh",
    //     display: "flex",
    //     justifyContent: "center",
    //     alignItems: "center",
    //     // backgroundColor: "#e4dcdc",
    //   }}
    // >
    <div className="page-wrapper book-demo-page">
      <div>{/* Contact Start */}
        <div className="container-xxl py-6">
          <div className="container">
            <div className="row g-5">

              {/* <div style={{ width: "100%", maxWidth: "900px", margin: "0 auto" }} data-wow-delay="0.5s"> */}
              <div className="demo-card" data-wow-delay="0.5s">
                <h1 className="display-6 mb-4 text-center">Book A Demo</h1>
                <form ref={formRef}
                  onSubmit={sendEmail}

                  method="POST"
                  target="_blank">
                  <div className="row g-3">
                    {/* <h6 className="text-primary text-uppercase mb-2">Enquire To Us</h6> */}
                    <div className="col-md-12">
                      <div className="form-floating">
                        <input type="text" className="form-control border-0 bg-light" id="name" name="name" placeholder="Your Name" required />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-floating">
                        <input type="comp_name" className="form-control border-0 bg-light" id="comp_name" name="comp_name" placeholder="Business Name" />
                        <label htmlFor="comp_name">Business Name</label>
                      </div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div className="form-floating">
                        <input type="email" className="form-control border-0 bg-light" id="email" name="email" placeholder="Your Email" />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-lg-6 col-12">
                      <div className="form-floating">
                        <input type="phone" className="form-control border-0 bg-light" id="phone" name="phone" placeholder="Your Phone" required />
                        <label htmlFor="phone">Your Phone</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <select
                          className="form-select border-0 bg-light"
                          id="subject"
                          name="subject"
                          defaultValue={product || ""}
                          required
                        >
                          <option value="" disabled>
                            Select a Product
                          </option>
                          <option value="eSchool">eSchool ERP - For Educational Institutions</option>
                          <option value="HabiTech">HabiTech - For Housing/Commercial Society</option>
                        </select>
                        <label htmlFor="subject">Product</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea className="form-control border-0 bg-light" placeholder="Leave a message here" id="message"
                          name="message" style={{ height: '150px' }} defaultValue={""} required />
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      {/* <button className="btn btn-primary py-3 px-5" type="submit">Submit</button> */}
                      <button className="btn btn-primary py-3 px-5 w-100" type="submit">Submit</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}</div>
  )
}

export default BookADemo
